import user from './server/user/user';
import career from './server/career/career';
import caregiver from './server/caregiver/caregiver';
import clientLead from './server/client_lead/client_lead';
import paymentSlip from './server/payment/slip';

import s3 from './aws/s3';

export default {
  s3,
  user,
  caregiver,
  career,
  clientLead,
  paymentSlip,
};
